module.exports = __webpack_public_path__ + "download/img/openapp1.ac4c1575.png";